module.exports = __webpack_public_path__ + "static/gq-spend-win-lpay-lat-banner-4baae2a458776e2226ed9586d36a401a.png";